var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.list, function(t, __i1__) {
    var m0 = _vm.$getImg(t.coverImagesUrl.split(",")[0])
    return {
      $orig: _vm.__get_orig(t),
      m0: m0
    }
  })

  var m1 = require("static/sound/release.png")

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        m1: m1
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }